




import { Component, Prop, Vue } from 'vue-property-decorator';
import { RedactModule } from './store/modules/redact';
import { getToken } from './utils/cookies';
import { UserModule } from './store/modules/user';

@Component({})
export default class App extends Vue {
  async created() {
    if (getToken()) {
      try {
        await UserModule.GetUserInfo();
        await RedactModule.GetPages();
      } catch (err) {
        console.log(err);
      }
    }
  }
}
